import { SxProps, Theme } from "@mui/material";

export const formContainer = (isMobile: boolean): SxProps<Theme> => ({
  width: "100%",
  maxWidth: isMobile ? "75%" : 400,
  display: "flex",
  flexDirection: "column",
  backgroundColor: "#fff",
  gap: 2,
  px: isMobile ? "24px" : "40px",
  py: isMobile ? "28px" : "48px",
  borderRadius: 2,
  boxShadow: 3,
  "@media (max-width: 390px)": {
    maxWidth: 250,
  },
});

export const headingStyles = (isMobile: boolean): SxProps<Theme> => ({
  fontSize: isMobile ? "20px" : "45px",
  marginBottom: 0.5,
});

export const descriptionStyles = (isMobile: boolean): SxProps<Theme> => ({
  marginBottom: 1,
  marginTop: 0.5,
  color: "gray",
  fontSize: isMobile ? "10px" : "14px",
});

export const inputContainerStyles: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 1,
};

export const inputLabelStyles: SxProps<Theme> = {
  fontSize: "0.75rem",
  color: "#333",
  fontWeight: 600,
};

export const textFieldStyles: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "5px",
    backgroundColor: "#F9F9F9",
    "& fieldset": {
      borderColor: "#333",
    },
  },
  mb: 1,
};
